import EmployeeDetail from './EmployeeDetail';
import { EmployeeJobsView } from '../../jobs/components/EmployeeJobsView';
import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getEmployeeById } from '../api';
import type { Employee } from '../types';

/**
 * EmployeeDetailPage - Page wrapper for the Employee detail view
 * 
 * All necessary providers (Customer, Services, Business, Jobs, Employees)
 * are provided at the route level in App.tsx
 */
export default function EmployeeDetailPage() {
  const { employeeId } = useParams<{ employeeId: string }>();
  const [employee, setEmployee] = useState<Employee | null>(null);

  useEffect(() => {
    if (employeeId) {
      getEmployeeById(employeeId).then(setEmployee);
    }
  }, [employeeId]);

  return (
    <div className="employee-detail-page">
      <EmployeeDetail />
      {employee && <EmployeeJobsView employee={employee} />}
    </div>
  );
}